import type { Rules } from "./Types";

const DEFAULT_RULES: Rules = {
    pointsToWin: 3,
    nsfw: false,
    roundLength: 10 * 60 * 1000, // 10 minutes
    visibility: "private",
    editor: "random",
};

export default DEFAULT_RULES;
